export default interface IMedicareCardError {
	medicareNumberError: string;
	irnError: string;
	expiryError: string;
	medicareNameError: string;
}

export const InitialMedicareCardErrorState: IMedicareCardError = {
	medicareNumberError: "",
	irnError: "",
	expiryError: "",
	medicareNameError: "",
};
